<template>
  <transition name="fade">
    <div v-if="ui.showSidenav" class="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden" @click.self="ui.closeSidenav">
      <div class="ml-auto flex h-full w-80 max-w-full flex-col overflow-y-auto bg-white shadow-2xl">
        <div class="relative bg-gradient-to-r from-brand/10 via-white to-brand/5 p-6">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <span class="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#FFE5EC] text-lg font-semibold text-[var(--accent)]">In</span>
              <div>
                <p class="text-lg font-semibold text-ink">Invi8</p>
                <p class="text-sm text-muted">Events & invites</p>
              </div>
            </div>
            <button class="rounded-full border border-gray-200 bg-white p-2 shadow-sm transition hover:-translate-y-0.5 hover:border-brand hover:text-brand" @click="ui.closeSidenav" aria-label="Close menu">
              <i class="ri-close-line text-lg"></i>
            </button>
          </div>
          <div class="mt-4 grid grid-cols-2 gap-2 text-xs font-semibold">
            <RouterLink class="rounded-full border border-gray-200 bg-white px-3 py-2 text-center text-ink shadow-sm transition hover:border-brand hover:text-brand" to="/login" @click="ui.closeSidenav">Log in</RouterLink>
            <RouterLink class="rounded-full bg-brand px-3 py-2 text-center text-white shadow-sm transition hover:bg-brandDark" to="/vendor-signup" @click="ui.closeSidenav">Register</RouterLink>
          </div>
        </div>

        <div class="flex-1 space-y-4 p-6 text-sm font-semibold text-ink">
          <div class="space-y-2">
            <p class="text-xs uppercase tracking-wide text-muted">Explore</p>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/" @click="ui.closeSidenav">Home</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/vendors" @click="ui.closeSidenav">Vendors</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/venues" @click="ui.closeSidenav">Venues</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/vendor-search" @click="ui.closeSidenav">Vendor Search</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/venue-search" @click="ui.closeSidenav">Venue Search</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/pricing" @click="ui.closeSidenav">Pricing</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/categories" @click="ui.closeSidenav">Categories</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/use-cases" @click="ui.closeSidenav">Use Cases</RouterLink>
          </div>

          <div class="space-y-2">
            <p class="text-xs uppercase tracking-wide text-muted">Learn</p>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/blog" @click="ui.closeSidenav">Blog</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/about" @click="ui.closeSidenav">About</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/contact" @click="ui.closeSidenav">Contact</RouterLink>
          </div>

          <div class="space-y-2">
            <p class="text-xs uppercase tracking-wide text-muted">Legal</p>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/privacy-policy" @click="ui.closeSidenav">Privacy Policy</RouterLink>
            <RouterLink class="block rounded-xl px-3 py-2 transition hover:bg-gray-50" to="/terms" @click="ui.closeSidenav">Terms & Conditions</RouterLink>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import { RouterLink, useRouter } from 'vue-router'
import { useUiStore } from '@/stores/ui'

const ui = useUiStore()
const router = useRouter()

const handleEsc = (event) => {
  if (event.key === 'Escape') ui.closeSidenav()
}

const removeAfterEach = router.afterEach(() => ui.closeSidenav())

onMounted(() => {
  window.addEventListener('keydown', handleEsc)
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleEsc)
  if (typeof removeAfterEach === 'function') removeAfterEach()
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
